<template>
<div id="app">
	<topbar></topbar>
	<shortcutbar></shortcutbar>
	<section class="app-main">
		<router-view></router-view>
	</section>
</div>
</template>

<script>
import Shortcutbar from "./components/navigation/Shortcutbar.vue"
import Topbar from "./components/navigation/Topbar.vue"
export default {
	name: 'app',
	components: {
		Shortcutbar,
		Topbar
	},
	data() {
		return {
			msg: 'Welcome to keepya'
		}
	}
}
</script>
<style lang="sass">

$family-app: "Source Sans Pro","Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",  "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif
$family-primary: $family-app

@import 'styles/colors.sass'
html
	font-size: 16px
	*
		box-sizing: border-box
		-webkit-font-smoothing: antialiased
body
	font-family: $family-app
	background: #7EA6B6
	background-image: radial-gradient(circle, #7EA6B6 0%, #1A5B72 100%)
	background-size: 100vw 100vh
	background-attachment: fixed
	min-height: 100vh
	color: #646F79
#app
	//margin: 60px
	padding: 70px 20px 20px 60px
.nav-item img
	margin-bottom: 0.25rem
	margin-top: 0.25rem
	width: 100px
	height: auto
.hide
	display: none
label.label
	font-weight: 500
.container > h3
	font-size: 1.25rem
	margin: 0 0 0.5rem
	border-bottom: 1px solid $grey-lighter
.main-stage
	background: #fff
	border-radius: 4px
	padding: 20px
.noselect
	-webkit-touch-callout: none; 
	-webkit-user-select: none; 
	-khtml-user-select: none; 
	-moz-user-select: none; 
	-ms-user-select: none;
	user-select: none;
</style>



// WEBPACK FOOTER //
// App.vue?f391730e